var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2H2C0.89543 2 0 2.89543 0 4V11C0 12.1046 0.89543 13 2 13H14C15.1046 13 16 12.1046 16 11V4C16 2.89543 15.1046 2 14 2ZM1.5 4C1.5 3.72386 1.72386 3.5 2 3.5H14C14.2761 3.5 14.5 3.72386 14.5 4V5.5H1.5V4ZM1.5 7V11C1.5 11.2761 1.72386 11.5 2 11.5H14C14.2761 11.5 14.5 11.2761 14.5 11V7H1.5ZM3 9C3 8.72386 3.22386 8.5 3.5 8.5H6.5C6.77614 8.5 7 8.72386 7 9C7 9.27614 6.77614 9.5 6.5 9.5H3.5C3.22386 9.5 3 9.27614 3 9ZM9 9C9 8.72386 9.22386 8.5 9.5 8.5H11.5C11.7761 8.5 12 8.72386 12 9C12 9.27614 11.7761 9.5 11.5 9.5H9.5C9.22386 9.5 9 9.27614 9 9Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/paymentIcon.adf391fa36881bfd85bfac9313de9e3f.svg";
export { ForwardRef as ReactComponent };